<template>
  <ValidationProvider
    tag="div"
    :rules="rules"
    :name="name"
    :vid="vid"
    v-slot="{ errors }"
    :mode="mode"
    class="custom-checkbox-list"
    :class="{
      'custom-checkbox-list--inline': inline,
    }"
  >
    <template v-if="options === null">
      <!-- <label class="checkbox" :class="{ 'is-invalid': !!errors.length }">
          <input v-model="currentValue" type="checkbox" :id="`${vid}`" />
          <span ref="checkbox"></span>
          <template v-if="!noLabel">{{ name }}</template>
        </label> -->
      <div
        class="custom-checkbox"
        :class="{
          'is-invalid': !!errors.length,
        }"
        ref="checkbox"
      >
        <span class="custom-checkbox__input">
          <input v-model="currentValue" type="checkbox" name="" id="" ref="checkbox" />
        </span>
        <span v-if="!noLabel" class="custom-checkbox__label">{{ name }}</span>
      </div>
    </template>
    <!-- <template v-else>
        <div v-for="(opt, index) in options" :key="opt.value" class="form-check" :class="{ 'form-check-inline': inline }">
          <input v-model="currentValue" class="form-check-input" type="checkbox" :value="opt.value" :id="`${vid}_${index}`" />
          <label class="form-check-label" :for="`${vid}_${index}`">
            {{ opt.label }}
          </label>
        </div>
      </template> -->
    <b-tooltip :target="() => $refs['checkbox']" :title="errors.length ? errors[0] : null" variant="danger" noninteractive placement="top" boundary="window"></b-tooltip>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { BTooltip } from "bootstrap-vue";
export default {
  name: "InputCheckbox",
  components: {
    ValidationProvider,
    BTooltip,
  },
  props: {
    value: {
      type: null,
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    vid: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: "text",
    },
    mode: {
      type: String,
      default: "eager",
    },
    inputClass: {
      type: String,
      default: "form-control-sm",
    },
    options: {
      type: [Array],
      default: null,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  watch: {
    currentValue(val) {
      this.$emit("input", val);
    },
  },
};
</script>
